import collapse from "@alpinejs/collapse";
import { scrollRefresh } from "../modules/animatePage.js";

// eslint-disable-next-line no-undef
Alpine.plugin(collapse);

export function openClose(Alpine) {
  return {
    open: false,
    windowSize: window.innerWidth,
    showbutton: false,

    init() {
      const vm = this;
      vm.checkHeight();
      setTimeout(() => {
        vm.countTextline();
      }, 500);
    },

    checkwindowResize() {
      this.windowSize = window.innerWidth;
      this.checkHeight();
      this.countTextline();
    },

    checkHeight() {
      // hide one line on mobile
      const wrappers = document.querySelectorAll(".js-open-close-wrapper");
      wrappers.forEach((wrapper) => {
        if (wrapper) {
          const des = wrapper.querySelector(".js-show-one-line--description");
          if (des) {
            if (!this.open) {
              if (this.windowSize < 1024) {
                setTimeout(() => {
                  des.style.height = 0;
                }, 50);
              } else {
                setTimeout(() => {
                  des.style.height = 25;
                }, 50);
              }
            }
          }
        }
      });
    },

    toggle(event) {
      this.open = !this.open;

      // hide one line on mobile
      const wrapper = event.target.closest(".js-open-close-wrapper");
      if (wrapper) {
        const des = wrapper.querySelector(".js-show-one-line--description");
        if (des) {
          if (this.windowSize < 1024) {
            if (!this.open) {
              setTimeout(() => {
                des.style.height = 0;
              }, 50);
            }
          }
        }
      }
      const accordionWrapper = event.target.closest(".js-accordion");
      const accordionBodyWrapper = accordionWrapper?.querySelector(".js-accordion-body");
      if (accordionBodyWrapper) {
        if (accordionBodyWrapper.classList.contains("!overflow-visible")) {
          accordionBodyWrapper.classList.remove("!overflow-visible");
        } else {
          setTimeout(() => {
            accordionBodyWrapper.classList.add("!overflow-visible");
          }, 500);
        }
      }
      setTimeout(() => {
        scrollRefresh();
      }, 200);
    },

    countTextline() {
      const textDescription = this.$refs.desc;
      if (textDescription) {
        const textHeight = textDescription.scrollHeight;
        this.showbutton = textHeight > 100;
        console.log(textHeight);
      } else {
        this.showbutton = true;
      }
    }
  };
}
